var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 105.54 100",
    style: {
      enableBackground: "new 0 0 105.54 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000047033930739860552040000007234642612748892849_);}\r\n\t.st2{fill:url(#SVGID_00000078728363906582339860000004108222385139539341_);}\r\n\t.st3{fill:url(#SVGID_00000109725880575499035520000004787571257075109009_);}\r\n\t.st4{fill:url(#SVGID_00000069371765371282034900000008698326100773778839_);}\r\n\t.st5{fill:url(#SVGID_00000081632840349535385410000001116976386819124905_);}\r\n\t.st6{fill:url(#SVGID_00000047767952270584011770000000057369716771873163_);}\r\n\t.st7{fill:url(#SVGID_00000051371801841225310920000013274822742879673778_);}\r\n\t.st8{fill:url(#SVGID_00000109729706962028771860000009275725838901948348_);}\r\n\t.st9{fill:url(#SVGID_00000094620442717000055060000007458977584011667886_);}\r\n\t.st10{fill:url(#SVGID_00000060746574459470315790000005439167165597937330_);}\r\n\t.st11{fill:url(#SVGID_00000043434202887846021490000017167587461559908768_);}\r\n\t.st12{fill:url(#SVGID_00000012442247103310692340000010574992172158842765_);}\r\n\t.st13{fill:url(#SVGID_00000026155048163536252320000006359359718748675757_);}\r\n\t.st14{fill:url(#SVGID_00000072258666126656424450000012821727351333178815_);}\r\n\t.st15{fill:url(#SVGID_00000180330965423356303830000016180819635647585690_);}\r\n\t.st16{fill:url(#SVGID_00000005967763896659897780000012550172731308701845_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.8436,
    y1: 16.2709,
    x2: 87.2075,
    y2: 93.9584
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.05
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.55,42.25h-0.01v-6.04h-3.46v7.76h0.01l5.86,3.97l2.07-2.76L16.55,42.25z M21.5,70.97 c-0.31-0.31-0.64-0.59-0.99-0.84c-0.13-0.09-0.27-0.18-0.41-0.26c-0.14-0.08-0.29-0.17-0.43-0.23c-0.14-0.07-0.29-0.14-0.43-0.2 c-0.03-0.02-0.06-0.03-0.08-0.03c-0.13-0.05-0.27-0.1-0.4-0.14c-0.34-0.1-0.69-0.19-1.06-0.24c-0.13-0.02-0.27-0.04-0.41-0.05 c-0.19-0.01-0.37-0.02-0.56-0.02h-0.18c-1.89,0-3.61,0.86-4.82,2.07H11.7c-0.65,0.69-1.13,1.48-1.45,2.31 c-0.08,0.21-0.16,0.41-0.21,0.63c-0.07,0.22-0.11,0.43-0.16,0.65c-0.17,0.86-0.17,1.75,0,2.61c0.07,0.42,0.2,0.84,0.36,1.25 c0.32,0.81,0.8,1.55,1.45,2.2l4.83,4.83v-0.01l4.83-4.99h0.01c0.34-0.3,0.64-0.65,0.9-1.02c0.77-1.13,1.16-2.51,1.16-3.81 C23.43,73.88,22.7,72.19,21.5,70.97z M38.96,8.63v3.44h3.46V8.63H38.96z M38.96,17.24v3.44h3.46v-3.44H38.96z M45.86,8.63v3.44 h20.7V8.63H45.86z M45.86,17.24v3.44h20.7v-3.44H45.86z M68.29,39.65H37.23c-1.03,0-1.73,0.69-1.73,1.73v44.83H70V41.38 C70,40.34,69.32,39.65,68.29,39.65z M35.5,89.66v8.62c0,1.03,0.69,1.73,1.73,1.73h31.05c1.03,0,1.72-0.69,1.72-1.73v-8.62H35.5z  M85.53,39.65v6.9h3.46v-6.9H85.53z M88.98,70.69v6.89h3.44v-6.89H88.98z M88.98,81.04v3.44h3.44v-3.44H88.98z M92.44,39.65v6.9 h3.44v-6.9H92.44z M100.58,29.78c-0.14-0.14-0.33-0.27-0.54-0.35c-0.21-0.08-0.46-0.12-0.71-0.12H82.07 c-0.52,0-0.95,0.18-1.24,0.48c-0.31,0.3-0.48,0.73-0.48,1.25v1.73h20.7v-1.73C101.06,30.52,100.88,30.08,100.58,29.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026879806335531197870000005619629750815828356_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.8511,
    y1: 33.8637,
    x2: 71.5713,
    y2: 99.1973
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000026879806335531197870000005619629750815828356_)"
    },
    points: "18.96,47.93 13.09,43.96  13.09,36.2 16.55,36.2 16.55,42.24 21.03,45.17  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021801439680838668760000004693507127810705324_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.0788,
    y1: 50.1164,
    x2: 54.6414,
    y2: 115.45
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021801439680838668760000004693507127810705324_)"
    },
    d: "M23.44,75.69c0,1.73-0.69,3.62-2.07,4.83 l-4.83,5l-4.83-4.83c-2.59-2.59-2.59-6.89,0-9.65c1.21-1.21,2.94-2.07,4.83-2.07h0.18C20.51,68.96,23.44,72.07,23.44,75.69z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035488752298291167540000001979779397000464562_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.1698,
    y1: 6.6778,
    x2: 99.89,
    y2: 72.0113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.97,
    y: 8.63,
    style: {
      fill: "url(#SVGID_00000035488752298291167540000001979779397000464562_)"
    },
    width: 3.46,
    height: 3.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051352543068531619790000016752065897391559093_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.865,
    y1: 10.8104,
    x2: 95.5852,
    y2: 76.144
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.97,
    y: 17.24,
    style: {
      fill: "url(#SVGID_00000051352543068531619790000016752065897391559093_)"
    },
    width: 3.46,
    height: 3.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139271625521040002230000008895107239217631375_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.2474,
    y1: -1.0767,
    x2: 107.9676,
    y2: 64.2568
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 45.87,
    y: 8.63,
    style: {
      fill: "url(#SVGID_00000139271625521040002230000008895107239217631375_)"
    },
    width: 20.7,
    height: 3.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058580839462848381780000002915950951424636810_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.9426,
    y1: 3.0559,
    x2: 103.6628,
    y2: 68.3895
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 45.87,
    y: 17.24,
    style: {
      fill: "url(#SVGID_00000058580839462848381780000002915950951424636810_)"
    },
    width: 20.7,
    height: 3.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010273958747488035220000009614745938816464561_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.2301,
    y1: 17.1799,
    x2: 88.9503,
    y2: 82.5135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49.32,
    y: 43.1,
    style: {
      fill: "url(#SVGID_00000010273958747488035220000009614745938816464561_)"
    },
    width: 6.9,
    height: 3.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051351702708721706780000010704717714290656139_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.2509,
    y1: 41.1599,
    x2: 63.9711,
    y2: 106.4935
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49.32,
    y: 93.1,
    style: {
      fill: "url(#SVGID_00000051351702708721706780000010704717714290656139_)"
    },
    width: 6.9,
    height: 3.46
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161593624128977069760000003749158206238808995_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.0436,
    y1: -0.8811,
    x2: 107.7638,
    y2: 64.4525
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 85.54,
    y: 39.65,
    style: {
      fill: "url(#SVGID_00000161593624128977069760000003749158206238808995_)"
    },
    width: 3.46,
    height: 6.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103966011025822149750000009997140042275428997_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.3326,
    y1: 12.2815,
    x2: 94.0528,
    y2: 77.6151
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88.99,
    y: 70.69,
    style: {
      fill: "url(#SVGID_00000103966011025822149750000009997140042275428997_)"
    },
    width: 3.44,
    height: 6.89
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136407823302957386950000017381499824300312493_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.0251,
    y1: 16.4167,
    x2: 89.7453,
    y2: 81.7503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88.99,
    y: 81.04,
    style: {
      fill: "url(#SVGID_00000136407823302957386950000017381499824300312493_)"
    },
    width: 3.44,
    height: 3.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160888343288372157340000002814464126547372216_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.6369,
    y1: -4.3307,
    x2: 111.3572,
    y2: 61.0029
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 92.45,
    y: 39.65,
    style: {
      fill: "url(#SVGID_00000160888343288372157340000002814464126547372216_)"
    },
    width: 3.44,
    height: 6.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128464837699422532760000005599629392172816318_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.6247,
    y1: -8.1589,
    x2: 115.3449,
    y2: 57.1746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128464837699422532760000005599629392172816318_)"
    },
    d: "M101.06,31.03v1.73h-20.7v-1.73 c0-1.03,0.68-1.73,1.72-1.73h17.25C100.37,29.3,101.06,30,101.06,31.03z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071536390880472791760000003370274966165931190_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.8231,
    y1: 16.2874,
    x2: 87.1869,
    y2: 93.9749
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.05
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071536390880472791760000003370274966165931190_)"
    },
    d: "M49.31,43.11v3.44h6.9v-3.44H49.31z  M49.31,93.1v3.46h6.9V93.1H49.31z M49.31,43.11v3.44h6.9v-3.44H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z M49.31,43.11v3.44h6.9 v-3.44H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z M49.31,43.11v3.44h6.9v-3.44H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z  M49.31,43.11v3.44h6.9v-3.44H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z M49.31,43.11v3.44h6.9v-3.44H49.31z M49.31,93.1v3.46h6.9 V93.1H49.31z M49.31,43.11v3.44h6.9v-3.44H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z M73.46,91.55c2.59-1.38,4.83-2.75,7.07-4.66 c5.18,5.69,13.8,6.04,19.5,0.87c5.69-5.17,6.03-13.8,0.86-19.49c-1.38-1.55-3.28-2.75-5.17-3.62c1.03-3.62,1.72-7.41,1.89-11.2 h1.73c2.93,0,5.17-2.24,5.17-5.17V31.03c0-2.93-2.24-5.17-5.17-5.17H97.6v-3.44h-3.44v3.44h-4.83 c-4.15-5.85-9.66-10.51-15.87-13.97V5.17c0-2.93-2.24-5.17-5.17-5.17H37.23c-2.93,0-5.17,2.24-5.17,5.17v6.72 c-7.59,3.96-13.8,10-18.11,17.41C6.35,29.83,0.66,36.38,1.02,43.96c0.34,4.66,2.93,8.79,7.07,11.21c0.35,4.14,1.21,8.28,2.59,12.06 c-4.66,3.1-6.03,9.49-2.75,14.32c0.34,0.52,0.86,1.03,1.2,1.55l7.42,7.41l5.7-5.69c2.92,2.75,6.19,5,9.8,6.88v-4.14 c-2.58-1.54-5.15-3.43-7.39-5.49c3.44-4.49,2.76-10.86-1.73-14.32c-1.73-1.38-3.96-2.23-6.38-2.23h-0.17 c-0.87,0-1.73,0.17-2.59,0.34c-1.04-2.93-1.9-6.21-2.24-9.31c7.42,1.73,14.83-2.93,16.55-10.34c1.73-7.42-2.93-14.82-10.34-16.55 h-0.18c3.62-5.69,8.45-10.34,14.32-13.8v6.56c0,2.93,2.24,5.17,5.18,5.17h9.65l5.87,5.87l5.87-5.87h9.84 c2.93,0,5.17-2.24,5.17-5.17v-6.56c4.48,2.6,8.45,6.04,11.55,10h-2.94c-2.93,0-5.17,2.24-5.17,5.17v17.24 c0,2.93,2.24,5.17,5.17,5.17h12.08c-0.18,3.62-0.87,7.07-1.9,10.52c-7.58-0.87-14.48,4.48-15.35,12.06 c-0.34,2.76,0.18,5.69,1.55,8.11c-1.55,1.2-3.27,2.41-5,3.44V91.55z M11.7,71.04h0.01c1.21-1.21,2.93-2.07,4.82-2.07h0.18 c0.19,0,0.37,0.01,0.56,0.02c0.14,0.01,0.28,0.03,0.41,0.05c0.36,0.05,0.71,0.13,1.06,0.24c0.13,0.04,0.27,0.09,0.4,0.14 c0.02,0,0.05,0.01,0.08,0.03c0.14,0.05,0.29,0.12,0.43,0.2c0.14,0.06,0.29,0.14,0.43,0.23c0.14,0.08,0.28,0.17,0.41,0.26 c0.35,0.25,0.68,0.53,0.99,0.84c1.2,1.22,1.93,2.91,1.93,4.72c0,1.29-0.39,2.68-1.16,3.81c-0.26,0.37-0.56,0.72-0.9,1.02h-0.01 l-4.83,4.99v0.01l-4.83-4.83c-0.65-0.65-1.13-1.4-1.45-2.2c-0.17-0.41-0.29-0.83-0.36-1.25c-0.17-0.86-0.17-1.75,0-2.61 c0.04-0.22,0.08-0.43,0.16-0.65c0.05-0.22,0.12-0.42,0.21-0.63C10.57,72.51,11.05,71.73,11.7,71.04z M21.02,45.17l-2.07,2.76 l-5.86-3.97h-0.01v-7.76h3.46v6.04h0.01L21.02,45.17z M42.41,20.69h-3.46v-3.44h3.46V20.69z M42.41,12.07h-3.46V8.63h3.46V12.07z  M66.56,20.69h-20.7v-3.44h20.7V20.69z M66.56,12.07h-20.7V8.63h20.7V12.07z M92.43,84.48h-3.44v-3.44h3.44V84.48z M92.43,77.58 h-3.44v-6.89h3.44V77.58z M80.36,32.76v-1.73c0-0.52,0.17-0.95,0.48-1.25c0.29-0.3,0.72-0.48,1.24-0.48h17.25 c0.26,0,0.51,0.04,0.71,0.12c0.21,0.08,0.39,0.21,0.54,0.35c0.3,0.3,0.48,0.73,0.48,1.25v1.73H80.36z M88.98,46.55h-3.46v-6.9h3.46 V46.55z M92.44,46.55v-6.9h3.44v6.9H92.44z M49.31,96.56h6.9V93.1h-6.9V96.56z M49.31,46.55h6.9v-3.44h-6.9V46.55z M49.31,93.1 v3.46h6.9V93.1H49.31z M49.31,43.11v3.44h6.9v-3.44H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z M49.31,43.11v3.44h6.9v-3.44H49.31z  M49.31,93.1v3.46h6.9V93.1H49.31z M49.31,43.11v3.44h6.9v-3.44H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z M49.31,43.11v3.44h6.9 v-3.44H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z M49.31,43.11v3.44h6.9v-3.44H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z M49.31,93.1 v3.46h6.9V93.1H49.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094601590856196105870000015089866226926408370_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.4914,
    y1: 56.0051,
    x2: 64.5938,
    y2: 82.1535
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.01
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094601590856196105870000015089866226926408370_)"
    },
    d: "M49.31,43.11v3.44h6.9v-3.44H49.31z  M49.31,93.1v3.46h6.9V93.1H49.31z M49.31,43.11v3.44h6.9v-3.44H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z M49.31,43.11v3.44h6.9 v-3.44H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z M49.31,43.11v3.44h6.9v-3.44H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z  M49.31,43.11v3.44h6.9v-3.44H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z M49.31,43.11v3.44h6.9v-3.44H49.31z M49.31,93.1v3.46h6.9 V93.1H49.31z M49.31,96.56h6.9V93.1h-6.9V96.56z M49.31,43.11v3.44h6.9v-3.44H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z  M49.31,43.11v3.44h6.9v-3.44H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z M49.31,43.11v3.44h6.9v-3.44H49.31z M49.31,93.1v3.46h6.9 V93.1H49.31z M49.31,43.11v3.44h6.9v-3.44H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z M49.31,43.11v3.44h6.9v-3.44H49.31z  M49.31,93.1v3.46h6.9V93.1H49.31z M49.31,93.1v3.46h6.9V93.1H49.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168832750760697535590000001323045384508175752_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.7429,
    y1: 29.173,
    x2: 76.4633,
    y2: 94.5068
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.01
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168832750760697535590000001323045384508175752_)"
    },
    d: "M49.32,93.1v3.46h6.9V93.1H49.32z  M49.32,93.1v3.46h6.9V93.1H49.32z M49.32,43.11v3.44h6.9v-3.44H49.32z M49.32,93.1v3.46h6.9V93.1H49.32z M49.32,43.11v3.44h6.9 v-3.44H49.32z M49.32,93.1v3.46h6.9V93.1H49.32z M49.32,43.11v3.44h6.9v-3.44H49.32z M49.32,93.1v3.46h6.9V93.1H49.32z M49.32,93.1 v3.46h6.9V93.1H49.32z M49.32,43.11v3.44h6.9v-3.44H49.32z M49.32,93.1v3.46h6.9V93.1H49.32z M49.32,43.11v3.44h6.9v-3.44H49.32z  M49.32,93.1v3.46h6.9V93.1H49.32z M49.32,43.11v3.44h6.9v-3.44H49.32z M49.32,93.1v3.46h6.9V93.1H49.32z M49.32,43.11v3.44h6.9 v-3.44H49.32z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.6cfd7b48d0716a6cfb3daca1727fcf75.svg";
export { ForwardRef as ReactComponent };